export default __webpack_public_path__ + "static/media/Gerlas-van-dan-Hoven.783f1c6d.jpeg";